export const getSalesEndingValue = (data: any) => {
  console.log("data", data);
  if (!data?.branch_is_shared_printer) {
    return data?.ending;
  }

  return (
    Number(data?.beginning || 0) +
    Number(data?.kertas_baru || 0) -
    Number(data?.kertas_hilang_kebuang || 0) -
    Number(data?.total_transaksi_dashboard || 0) -
    Number(data?.total_kesalahan_fraud || 0)
  );
};